import { all, fork } from 'redux-saga/effects'
import getNotificationsSaga from './getNotificationsSaga'

export default function* reactionsSaga(params) {
  yield all([fork(getNotificationsSaga, params)])
}
